import React from 'react';
import { Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';

/**
 * StockChip — Clickable chip that navigates to a stock's detail page.
 *
 * @param {string} symbol - Stock ticker symbol
 * @param {function} [onClick] - Optional custom click handler (overrides navigation)
 */
const StockChip = ({ symbol, onClick }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.stopPropagation();
    if (onClick) {
      onClick(symbol);
    } else {
      navigate(`/stock/${symbol}`);
    }
  };

  return (
    <Chip
      label={symbol}
      size="small"
      onClick={handleClick}
      sx={{
        fontWeight: 600,
        fontSize: '0.75rem',
        cursor: 'pointer',
        backgroundColor: 'action.hover',
        color: 'primary.main',
        '&:hover': {
          backgroundColor: 'action.selected',
        },
      }}
    />
  );
};

export default StockChip;
